export function isAndroidFrom(input) {
  const uaData = input ? input.uaData : null;
  if (uaData && typeof uaData.platform === 'string' && uaData.platform !== '') {
    return uaData.platform === 'Android';
  }
  return /Android/i.test(String((input && input.ua) || ''));
}

export function isChromiumAndroidFrom(input) {
  const uaData = input ? input.uaData : null;
  return !!uaData && uaData.platform === 'Android';
}

function navigatorInput() {
  let uaData = null;
  let ua = '';
  try {
    uaData = navigator.userAgentData || null;
  } catch {
    uaData = null;
  }
  try {
    ua = navigator.userAgent;
  } catch {
    ua = '';
  }
  return { uaData, ua };
}

export function isAndroid() {
  if (typeof navigator === 'undefined') return false;
  return isAndroidFrom(navigatorInput());
}

export function isChromiumAndroid() {
  if (typeof navigator === 'undefined') return false;
  return isChromiumAndroidFrom(navigatorInput());
}
